import instance from '@/service/instance';
import { AxiosPromise } from 'axios';
import {Coupon} from '@/helpers/types'

const resource: string = '/coupon';

export default {
  list(token: string): AxiosPromise<Coupon[]> {
    return instance.get(resource, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  create({token, payload}: { token: string, payload: any }): AxiosPromise<Coupon> {
    return instance.post(resource, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  activateByEmail(payload: any): AxiosPromise<void> {
    return instance.post(`${resource}/activate-email`, payload)
  }
}
